// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
  orderBy,
  runTransaction,
  serverTimestamp,
  updateDoc,
  setDoc,
  addDoc,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";

// Firebase configuration (loaded from environment variables)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Core services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

const region = process.env.REACT_APP_FIREBASE_REGION || "us-central1";
export const functions = getFunctions(app, region);

if (
  typeof window !== "undefined" &&
  process.env.NODE_ENV === "development" &&
  window.location.hostname === "localhost"
) {
  try {
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    console.info("⚙️ Connected Firebase functions emulator at 127.0.0.1:5001");
  } catch (err) {
    console.warn("Failed to connect functions emulator", err);
  }
}

// Re-export Firestore helpers for convenience
export {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
  orderBy,
  runTransaction,
  serverTimestamp,
  updateDoc,
  setDoc,
  addDoc,
};

// Re-export Storage helpers
export { ref, uploadBytes, getDownloadURL };

// Re-export callable helper
export { httpsCallable };

export default app;
